export const deepClone = (object) => {
    return object ? JSON.parse(JSON.stringify(object)) : false;
}